// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"281":"alias","596":"404","760":"card","963":"send"}[chunkId] + "." + {"281":"e82a9dd0","596":"f11f024b","760":"627ba1f6","963":"93931816"}[chunkId] + ".css";
};